/** @format */

import React from 'react';
import { Card, Button } from 'antd';
import { Customer } from '../types/customer';

interface AddressInfoCardProps {
  customer: Customer;
  isEditing: boolean;
  onToggleEdit: () => void;
  onCancelEdit: () => void;
  onAddressChange: (field: string, value: any) => void;
}

const AddressInfoCard: React.FC<AddressInfoCardProps> = ({
  customer,
  isEditing,
  onToggleEdit,
  onCancelEdit,
  onAddressChange,
}) => {
  return (
    <Card
      title="Address Information"
      extra={
        isEditing ? (
          <>
            <Button onClick={onToggleEdit} style={{ marginRight: '8px' }}>
              Save
            </Button>
            <Button onClick={onCancelEdit}>
              Cancel
            </Button>
          </>
        ) : (
          <Button onClick={onToggleEdit}>
            Edit
          </Button>
        )
      }
    >
      <div style={{ padding: '10px' }}>
        <p>
          <strong>Street:</strong>{' '}
          {isEditing ? (
            <input
              type="text"
              value={customer.address?.street || ''}
              onChange={(e) => onAddressChange('street', e.target.value)}
            />
          ) : (
            customer.address?.street || 'N/A'
          )}
        </p>
        <p>
          <strong>City:</strong>{' '}
          {isEditing ? (
            <input
              type="text"
              value={customer.address?.city || ''}
              onChange={(e) => onAddressChange('city', e.target.value)}
            />
          ) : (
            customer.address?.city || 'N/A'
          )}
        </p>
        <p>
          <strong>State:</strong>{' '}
          {isEditing ? (
            <input
              type="text"
              value={customer.address?.state || ''}
              onChange={(e) => onAddressChange('state', e.target.value)}
            />
          ) : (
            customer.address?.state || 'N/A'
          )}
        </p>
        <p>
          <strong>Apt/Unit:</strong>{' '}
          {isEditing ? (
            <input
              type="text"
              value={customer.address?.aptUnite || ''}
              onChange={(e) => onAddressChange('aptUnite', e.target.value)}
            />
          ) : (
            customer.address?.aptUnite || 'N/A'
          )}
        </p>
        <p>
          <strong>Postal Code:</strong>{' '}
          {isEditing ? (
            <input
              type="text"
              value={customer.address?.zipCode || customer.address?.postalCode || ''}
              onChange={(e) => onAddressChange('zipCode', e.target.value)}
            />
          ) : (
            customer.address?.postalCode || customer.address?.zipCode || 'N/A'
          )}
        </p>
        <p>
          <strong>Country:</strong>{' '}
          {isEditing ? (
            <input
              type="text"
              value={customer.address?.country || ''}
              onChange={(e) => onAddressChange('country', e.target.value)}
            />
          ) : (
            customer.address?.country || 'N/A'
          )}
        </p>
      </div>
    </Card>
  );
};

export default AddressInfoCard;
